// extracted by mini-css-extract-plugin
module.exports = {"RQoverlay":"RQModal_RQoverlay__2kWws","RQmodal":"RQModal_RQmodal__3tVkA","RQwrapper":"RQModal_RQwrapper__1D7bY","h2":"RQModal_h2__3hqBt","RQclose":"RQModal_RQclose__3oxa8"};